import React from "react";
import IMAGES from "utils/constants/image";
import { styles } from "./styles";
import AcceptedPaymentMethods from "components/AcceptedPaymentMethods";
import Input from "components/Form/fields/Input";
import Button from "components/Form/fields/Button";
import { getConfig } from "utils/env";
import PATHS from "utils/paths";
import { BUTTON_TAGS } from "utils/constants/ui";
import { formFactorAction } from "utils/view";
import Link from "next/link";

const DEFAULT_CREATOR_PAGE = "/shanedjrogers";

const GetSupport = () => {
  const prefix = `${getConfig("WEB_CLIENT_ROOT")}/`;

  const signupAction = (
    <Button href={PATHS.SIGNUP} tag={BUTTON_TAGS.LINK} copy="Signup" />
  );

  return (
    <section className="tl w-100 mt0 mt4-ns dib pt3 flex flex-column flex-row-ns justify-between-ns">
      <div className="w-100 w-two-thirds-ns fl flex flex-column order-1 order-0-ns pt4 pt0-ns">
        <div className="flex flex-column pb3">
          <div className="f3 f2-l fw6 mb2 mt0-ns tl lh-title w-90">
            Tip pages
          </div>
          <div className="f5 f4-l fw4 mt0-ns tl lh-copy pt2 pr3">
            {`Build a custom tip page to receive support from your community, in just
            a few ${formFactorAction().toLowerCase()}s.`}
          </div>
        </div>
        <div className="w-100 db pt2">
          <div className="fw6 f4">Get paid faster</div>
          <div className="pt2 f5 f4-l lh-copy">
            Give your supporters the best checkout experience possible and get
            paid faster. Apple Pay and Google Pay enabled by default.
          </div>
        </div>
        <div className="w-100 db pt4">
          <div className="fw6 f4">Customize your page</div>
          <div className="pt2 f5 f4-l lh-copy">
            Create your profile, with social links and payment options. Accept
            one time or recurring payments from your supporters.
          </div>
        </div>
        <div className="w-100 db pt4">
          <div className="fw6 f4">Branded links</div>
          <div className="pt2 f5 f4-l lh-copy">
            Choose a unique branded link for your page, which you can share
            anywhere.
          </div>
          <div className="w-100 flex flex-row relative pt2">
            <div className="w-100 flex flex-row items-stretch">
              {prefix && (
                <div className="flex items-center justify-center flex-shrink-0 h-auto br2 br--left bl bt bb brn b--black-20 bg-content--secondary ph2">
                  <div className="field__label fw5 db">{prefix}</div>
                </div>
              )}
              <div className="w-100 relative">
                <Input
                  customClasses={{
                    input:
                      "f5 border-box input-reset ba pa2 db w-100 lh-copy b--black-20 br--right br2"
                  }}
                />
              </div>
              <div className="pl2 dn dib-ns">{signupAction}</div>
            </div>
          </div>
          <div className="pt2 db dn-ns">{signupAction}</div>
        </div>
        <div className="pt4">
          <AcceptedPaymentMethods />
        </div>
      </div>
      <Link href={DEFAULT_CREATOR_PAGE}>
        <div className="w-100 w-third-ns fr pointer">
          <div
            className={`${IMAGES.PAGES_CREATORS_SUPPORT}--wrapper cell-grow`}
          >
            <div
              className={`${IMAGES.PAGES_CREATORS_SUPPORT}--img contain contain`}
            />
          </div>
        </div>
      </Link>
      <style jsx>{styles}</style>
    </section>
  );
};

export default GetSupport;
